<template>
  <v-container class="mt-3">
    <div>
      <v-data-table
        :headers="headers"
        :items="rules"
        :page.sync="page"
        :items-per-page="5"
        @page-count="pageCount = $event"
        class="
          elevation-1
          pa-3
          font-weight-regular
          blue--text
          text--darken-4">
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>
              Regras de Usuários
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              dark
              class="mb-2"
              @click="$router.push('/newrule')">
              <v-icon left>add</v-icon>Adicionar Regra
            </v-btn>
          </v-toolbar>
        </template>

        <template v-slot:[`item.status`]="{ item }">
          <v-chip
            :class="getTextColor(item.status)"
            label
            :color="getColor(item.status)"
            dark>
            {{ item.status && item.status === true ? "Ativo": item.status === false ? "Desativado" : "Pendente" }}
          </v-chip>
        </template>

        <template v-slot:item.created_at="{ item }">
          <span>{{formatDate(item.created_at)}}</span>
        </template>

        <template v-slot:item.actions="{ item }">

          <v-tooltip v-if="item.status === true" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                color="error"
                @click="disableItem(item)">
                account_tree
              </v-icon>
            </template>
            <span>Desabilitar regra</span>
          </v-tooltip>

          <v-tooltip v-else top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="success"
                v-bind="attrs"
                v-on="on"
                @click="enableItem(item)">
                account_tree
              </v-icon>
            </template>
            <span>Habilitar regra</span>
          </v-tooltip>

        </template>
      </v-data-table>
      <div
        class="text-center pt-2">
        <v-pagination
          v-model="page"
          :length="pageCount">
        </v-pagination>
      </div>
    </div>
  </v-container>
</template>

<script>
var moment = require("moment");
export default {
  data: () => ({
    dialog: false,
    page: 1,
    pageCount: 0,
    headers: [
      { text: "Nome", align: "start", sortable: false, value: "display_name" },
      { text: "Status", value: "status", sortable: false },
      { text: "Data de Registro", value: "created_at", sortable: false },
      { text: "Ações", value: "actions", sortable: false }
    ],
    desserts: [],
    editedIndex: -1,
    editedItem: {
      vtr: "",
      type: "",
      placa: "",
      date: "",
      base: ""
    },
    defaultItem: {
      vtr: "",
      type: "",
      placa: "",
      date: "",
      base: ""
    }
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nova Viatura" : "Editar Viatura";
    },
    rules(){
      console.log('rs', this.$store.getters.rules)
      return this.$store.getters.rules
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  async created (){
    await this.$store.dispatch('loadRules')
  },

  methods: {
    getColor (status) {

      if (status === true) return 'green lighten-4'
      else if (status === false) return 'red lighten-4'
      else return 'amber lighten-4'
    },
    getTextColor (status) {

      if (status === true) return 'green--text'
      else if (status === false) return 'red--text'
      else return 'orange--text'
    },

    async disableItem (item) {
      item.status = false;
      let novo = {
        status: item.status+"",
        id: item.id
      };
      let res = await this.$store.dispatch('updateProfile', novo);
    },

    async enableItem (item) {
      item.status = true;
      let novo = {
        status: item.status+"",
        id: item.id
      };
      let res = await this.$store.dispatch('updateProfile', novo);
    },

    formatDate(date){
      return moment(date,'YYYY-MM-DD').format('DD/MM/YYYY')
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.desserts.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.desserts.splice(index, 1);
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
      }
      this.close();
    }
  }
};
</script>

<style scoped>
</style>
